import React, { useEffect } from "react";
import Card from "./Card";
import styled, { keyframes } from "styled-components";
import GameRule from "./Types/GameRule";
import Direction from "./Types/Direction";
import Player from "./Types/Player";
import { useSoundContext } from "./Hooks/useGameSound";

const pulse = keyframes`
	0% {
		transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  
  20% {
		transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  30% {
		transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  
  40% {
		transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  50% {
		transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  
  60% {
		transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
		transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  80% {
		transform: scale(0.95);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  90% {
		transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

	100% {
		transform: scale(0);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
`;

const InterestContainer = styled.div<Partial<Props>>`
  position: absolute;
  ${({ direction }) =>
    direction === Direction.Up ? `bottom: 15px;` : `top: 15px;`}
`;

const Interest = styled.div<Partial<Props>>`
  animation: ${pulse} 3s linear forwards;
  font-size: 2rem;
  background: linear-gradient(to bottom right, #403c22, #26242e);
  color: white;
  padding: 5px;
  border-radius: 10px;
`;

interface Props {
  direction: Direction;
  onShowInterest: (pileIndex: number) => void;
  selectedCard?: number;
  index: number;
  number: number;
  numberOfCards?: number;
  enabled: boolean;
  isSpeakingAllowed: boolean;
  gameRule: GameRule;
  interestedPlayers: Player[];
  gameId: number;
}

const Pile = ({
  direction,
  selectedCard,
  index,
  numberOfCards,
  number = direction,
  enabled,
  gameRule,
  isSpeakingAllowed,
  interestedPlayers,
  onShowInterest,
  gameId,
}: Props) => {
  const { playSound } = useSoundContext();
  useEffect(() => {
    playSound("cardPlayed");
  }, [number, playSound]);
  return (
    <Card
      enabled={enabled && !!selectedCard}
      direction={direction}
      onClick={() => (isSpeakingAllowed ? onShowInterest(index) : {})}
      isHighlighted={number > 1 && number < 99}
      hideThickBorder={!!numberOfCards && numberOfCards > 0}
      number={number}
      gameRule={gameRule}
      key={number}
      gameId={gameId}
    >
      <InterestContainer direction={direction}>
        {interestedPlayers.map(
          (p) =>
            p && (
              <Interest
                direction={direction}
                key={p.name + p.interest?.timestamp}
              >
                {p.name}
              </Interest>
            )
        )}
      </InterestContainer>
      {number}
    </Card>
  );
};

export default Pile;
